// src/components/NoteModal.js
import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  TextField,
  Box,
  Typography,
  IconButton,
  Divider,
  Paper,
  Fade,
  Backdrop,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import { updateNoteForDeclaration } from "../../api/declaration/updateNoteForDeclaration";
import Swal from "sweetalert2";

const NoteModal = ({ open, handleClose, note, id, search, base64 }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedNote, setEditedNote] = useState(null);

  useEffect(() => {
    console.log(note, "note");
    setEditedNote(note);
  }, [note]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    console.log(editedNote, "editedNote");
    await updateNoteForDeclaration(
      editedNote === null ? note : editedNote?.length > 0 ? editedNote : "",
      id
    )
      .then(async (resp) => {
        Swal.fire({
          title: "Başarılı",
          text: resp?.data?.message || "Not Güncellendi",
          icon: "success",
          confirmButtonText: "Tamam",
        });
        await search();
        setIsEditing(false);
      })
      .catch((err) => {
        Swal.fire({
          title: "Başarısız",
          text: err?.response?.data?.message || "Güncelleme Hatası",
          icon: "error",
          confirmButtonText: "Tamam",
        });
        console.log(err, "err");
        setIsEditing(false);
        setEditedNote(null);
        handleClose();
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        setEditedNote(null);
        setIsEditing(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Paper
          elevation={6}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: base64 ? "80vw" : "50vw",
            height: base64 ? "80vh" : "50vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 3,
            overflow: "hidden",
            display: "flex", // Paper'ı flex container yap
            flexDirection: "column", // İçeriği dikey olarak düzenle
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: "#f5f5f5",
              p: 2,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#546e7a",
                fontWeight: 500,
              }}
            >
              <NoteAltIcon sx={{ mr: 1 }} /> Not Detayı
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flex: 1, // Geriye kalan tüm alanı doldur
              overflow: "hidden", // İçerik taşarsa kaydırma çubuğu göster
            }}
          >
            {/* PDF Viewer */}
            {base64 && (
              <Box
                sx={{
                  width: "65%",
                  height: "100%",
                  borderRight: "1px solid #e0e0e0",
                }}
              >
                <iframe
                  style={{ width: "100%", height: "100%", border: "none" }}
                  src={`data:application/pdf;base64,${base64}`}
                  title="PDF Viewer"
                />
              </Box>
            )}

            {/* Note Section */}
            <Box
              sx={{
                width: base64 ? "35%" : "100%", // PDF yoksa %100 genişlik kullan
                height: base64 ? "70%" : "90%",
                p: 3,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden", // Taşma olmaması için
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  mb: 2,
                  color: "#546e7a",
                  fontWeight: 500,
                }}
              >
                Not İçeriği
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  bgcolor: "#f9f9f9",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  maxHeight: "50vh",
                  overflow: "hidden", // Taşan içeriği gizle
                }}
              >
                {isEditing ? (
                  <TextField
                    fullWidth
                    multiline
                    variant="outlined"
                    sx={{
                      width: "99%",
                      m: 1,
                      height: "100%",
                      "& .MuiOutlinedInput-root": {
                        border: "none",
                        borderRadius: 2,
                        "& fieldset": { border: "none" },
                      },
                    }}
                    InputProps={{
                      sx: {
                        wordWrap: "break-word",
                        whiteSpace: "pre-wrap",
                        padding: 1,
                        fontSize: "1.2rem",
                        maxHeight: "100%", // Yüksekliği sınırla
                        overflowY: "auto", // İçerik taştığında kaydırma çubuğu ekle
                        wordWrap: "break-word",
                        whiteSpace: "pre-wrap",
                      },
                    }}
                    value={editedNote || ""}
                    onChange={(e) => setEditedNote(e.target.value)}
                    placeholder="Not içeriğini buraya giriniz..."
                  />
                ) : (
                  <Typography
                    sx={{
                      wordWrap: "break-word",
                      whiteSpace: "pre-wrap",
                      height: "100%", // Yüksekliği %40 yerine %100 yap
                      maxHeight: "100%", // maxHeight Box ile aynı değerde olmalı
                      overflowY: "auto", // İçerik taştığında kaydırma çubuğu ekle
                      padding: 2,
                      fontSize: "1.2rem",
                      color: "#37474f",
                      boxSizing: "border-box", // Padding dahil boyutu hesapla
                    }}
                  >
                    {editedNote || note || "Not bulunmamaktadır."}
                  </Typography>
                )}
              </Box>

              <Divider sx={{ mb: 2 }} />

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  // mt: "auto",
                }}
              >
                {!isEditing ? (
                  <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={handleEditClick}
                    sx={{
                      borderRadius: 2,
                      mr: 1,
                      color: "#546e7a",
                      borderColor: "#546e7a",
                      "&:hover": {
                        borderColor: "#455a64",
                        bgcolor: "rgba(84, 110, 122, 0.04)",
                      },
                    }}
                  >
                    Düzenle
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsEditing(false);
                      setEditedNote(note);
                    }}
                    sx={{
                      borderRadius: 2,
                      mr: 1,
                      color: "#546e7a",
                      borderColor: "#546e7a",
                    }}
                  >
                    İptal
                  </Button>
                )}
                <Button
                  variant="contained"
                  startIcon={<SaveIcon />}
                  onClick={handleSaveClick}
                  disabled={!isEditing}
                  sx={{
                    borderRadius: 2,
                    bgcolor: "#4caf50",
                    "&:hover": {
                      bgcolor: "#43a047",
                    },
                    "&:disabled": {
                      bgcolor: "#e0e0e0",
                      color: "#9e9e9e",
                    },
                  }}
                >
                  Kaydet
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default NoteModal;
